export default __webpack_public_path__ + "static/media/ic_scholarship_active.8a7ded68.svg";